function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Bell({
  width = 31,
  height = 31,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M15.5 22.784c7.284 0 10.654-.904 10.98-4.533 0-3.627-2.35-3.393-2.35-7.843 0-3.476-3.405-7.43-8.63-7.43-5.225 0-8.63 3.954-8.63 7.43 0 4.45-2.349 4.216-2.349 7.843.327 3.643 3.696 4.533 10.98 4.533z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M18.585 26.546c-1.762 1.893-4.51 1.916-6.29 0",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Bell.js.map